export default __webpack_public_path__ + "static/media/LogoPortoBranca.615d6737.png";